import React, { ReactNode } from "react"
import clsx from "clsx"
import { BaseStyles } from "ui/types/base-styles"
import { generateStylesFromProps } from "ui/utils/styles"

import { H1, H2, H3, H4, LabelH1, LabelH2, LabelH3 } from "./index"
import { Label } from "./Label"
import styles from "./Typography.module.css"

export type TitleProps = BaseStyles & {
  children: ReactNode
  $type?: "primary" | "secondary" | "third" | "fourth"
  elementType?: "h" | "label"
  label?: string

  $styleType?: "primary" | "secondary" | "third" | "fourth"
  $color?: string
  $labelColor?: string
  $center?: boolean
}

export const Title = ({
  $type = "secondary",
  children,
  label,
  elementType = "h",
  $styleType,
  $color,
  $labelColor = "primary",
  $center,
  className = "",
  style = {},
  ...rest
}: TitleProps & { className?: string; style?: React.CSSProperties }) => {
  const generatedStyles = generateStylesFromProps(rest)

  const wrapperClasses = clsx(
    styles.titleWrapper,
    {
      [styles.center]: $center,
    },
    className,
  )

  const wrapperStyles = {
    ...generatedStyles,
    ...style,
  }

  let obj
  if (elementType === "h") {
    if ($type === "primary") {
      obj = (
        <H1 $color={$color} $styleType={$styleType ?? "primary"} {...rest}>
          {children}
        </H1>
      )
    }
    if ($type === "secondary") {
      obj = (
        <H2 $color={$color} $styleType={$styleType ?? "secondary"} {...rest}>
          {children}
        </H2>
      )
    }
    if ($type === "third") {
      obj = (
        <H3 $color={$color} $styleType={$styleType ?? "third"} {...rest}>
          {children}
        </H3>
      )
    }
  } else {
    if ($type === "primary") {
      obj = (
        <LabelH1 $color={$color} $styleType={$styleType ?? "primary"} {...rest}>
          {children}
        </LabelH1>
      )
    }
    if ($type === "secondary") {
      obj = (
        <LabelH2 $color={$color} $styleType={$styleType ?? "secondary"} {...rest}>
          {children}
        </LabelH2>
      )
    }
    if ($type === "third") {
      obj = (
        <LabelH3 $color={$color} $styleType={$styleType ?? "third"} {...rest}>
          {children}
        </LabelH3>
      )
    }
  }

  if ($type === "fourth") {
    obj = (
      <H4 $color={$color} $styleType={$styleType ?? "fourth"} {...rest}>
        {children}
      </H4>
    )
  }

  return (
    <div className={wrapperClasses} style={wrapperStyles}>
      {label && (
        <Label $type="third" $marginBottom="0" $color={$labelColor} $textTransform="uppercase">
          {label}
        </Label>
      )}
      {obj}
    </div>
  )
}
